import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listWineTypesFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV1RootUrl()}/product/filter/wine-type/for-web?${urlString}`,
    publicAxiosHeader()
  );
};

export const listWineVarietalsFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV1RootUrl()}/product/filter/wine-varietal/for-web?${urlString}`,
    publicAxiosHeader()
  );
};

export const listWineCountryCodesFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV1RootUrl()}/product/filter/wine-country-code/for-web?${urlString}`,
    publicAxiosHeader()
  );
};

export const listWineRegionsFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV1RootUrl()}/product/filter/wine-region/for-web?${urlString}`,
    publicAxiosHeader()
  );
};

export const listWineAppellationsFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV1RootUrl()}/product/filter/wine-appellation/for-web?${urlString}`,
    publicAxiosHeader()
  );
};

export const listVendorsFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV1RootUrl()}/product/filter/vendor/for-web?${urlString}`,
    publicAxiosHeader()
  );
};
